<label *ngIf="!!labelText"
       class="mat-form-field-label">
    {{ labelText }}
</label>
<mat-radio-group [value]="currentValue"
                 [disabled]="disabled"
                 (change)="onChange($event)"
                 (click)="onClick()">
    <mat-radio-button [value]="true"
                      class="toggle-switch">
        {{onString}}
    </mat-radio-button>
    <mat-radio-button [value]="false"
                      class="toggle-switch">
        {{offString}}
    </mat-radio-button>
</mat-radio-group>
